import {
  Home, Tag, KeyRound, TrendingUp, Landmark, LineChart, Calculator,
  Scale, HardHat, Sofa, Receipt, MapPinned, Rocket, UserCheck, Sparkles,
} from "lucide-react";

const MAP = {
  Home, Tag, KeyRound, TrendingUp, Landmark, LineChart, Calculator,
  Scale, HardHat, Sofa, Receipt, MapPinned, Rocket, UserCheck, Sparkles,
};

// Renders a lucide icon by name with a safe fallback.
export const KbIcon = ({ name, className }) => {
  const C = MAP[name] || Sparkles;
  return <C className={className} />;
};

export default KbIcon;
